function waitForJQuery(callback) {
  if (typeof jQuery !== "undefined") {
    callback();
  } else {
    setTimeout(() => waitForJQuery(callback), 100);
  }
}

waitForJQuery(() => {
  (function ($) {
    // =========================
    // VARIÁVEIS GLOBAIS / STATE
    // =========================
    const QUIZ_KEY = "quiz_responses_v2";
    let forceSequentialFromStep = null;

    let quizState = {
      currentStep: 0,
      responses: loadQuizResponses(),
      scores: {},
    };

    // ---- GTM events ----
    let quizHasStarted = false;
    const EVENT_NAMES = {
      goal: "quiz_goal_answered",
      frequency: "quiz_exercise_frequency_answered",
      exercise_type: "quiz_exercise_type_answered",
      gender: "quiz_gender_answered",
      meal_qty: "quiz_meals_per_day_answered",
      meal_split: "quiz_meal_source_answered",
      pk_qty: "quiz_meals_to_replace_answered",
      used_delivery: "quiz_previous_service_answered",
      form_submitted: "quiz_form_submitted",
      completed: "quiz_completed",
      start: "quiz_start",
      skipped: "quiz_completed_skipped_form"
    };

    function pushQuizEvent(eventName, step, answer) {
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: eventName,
          step: step ? { key: step.key, question: step.question } : undefined,
          answer: answer
            ? { value: answer.value, label: answer.label }
            : undefined,
        });
        console.log("[GTM] push", eventName, step?.key, answer);
      } catch (e) {
        // no-op
      }
    }

    // Posiciona no primeiro step não respondido
    if (quizState.responses && quizState.responses.length > 0) {
      let i = 0;
      while (
        i < window.quizSteps.length &&
        quizState.responses[i] &&
        (quizState.responses[i].idx !== undefined ||
          quizState.responses[i].split ||
          quizState.responses[i].value !== undefined)
      ) {
        i++;
      }
      quizState.currentStep = i;
    }

    // ======================
    // MÉTODOS DO QUIZ
    // ======================
    const QuizMethods = {
      render: function () {
        updateProgressBar(quizState.currentStep, window.progressSteps.length);
        const $container = $("#quiz-container");
        $container.removeClass("last-step");
        $container.empty();

        // Fim
        if (quizState.currentStep >= window.quizSteps.length) {
          forceSequentialFromStep = null;
          QuizMethods.renderResult($container);
          $("#quiz-banner").fadeOut(200);
          return;
        }

        const step = window.quizSteps[quizState.currentStep];
        if (step.banner) {
          showQuizBanner(step.banner);
        }
        // Header/back
        const $backBtn = $(".quiz-back-btn");
        quizState.currentStep > 0
          ? $backBtn.removeClass("hidden")
          : $backBtn.addClass("hidden");
        $backBtn.off("click").on("click", function () {
          QuizMethods.goBack();
        });

        // Título e descrição
        const $questionBox = $("<div/>", { class: "quiz-title" });
        const $question = $("<div/>", {
          class: "quiz-question",
          text: step.question,
        });
        $questionBox.append($question);
        $container.append($questionBox);

        if (step.description) {
          $container.append(
            $("<div/>", { class: "quiz-description", text: step.description })
          );
        }

        // ======================
        // SLIDER STEP (meal_split)
        // ======================
        if (step.isSliderStep) {
          const prevStep = window.quizSteps.find((s) => s.key === "meal_qty");
          const prevResp =
            quizState.responses[
              window.quizSteps.findIndex((s) => s.key === "meal_qty")
            ];
          const perDay = Number(prevStep.options[prevResp?.idx]?.value) || 1;
          const totalMeals = perDay * 7;

          let mealSplit = Array.isArray(
            quizState.responses[quizState.currentStep]?.split
          )
            ? [...quizState.responses[quizState.currentStep].split]
            : [0, 0, 0];

          const $sliderBox = $("<div/>", { class: "quiz-slider-step" });

          const $progressContainer = $(`
            <div class="progress-container">
              <div class="progress-header">
                <span>Meals distributed</span>
                <span id="meals-counter">0/${totalMeals}</span>
              </div>
              <div class="progress-bar-bg">
                <div class="progress-bar-fill" id="progress-bar"></div>
              </div>
            </div>
          `);

          const updateProgressBar = () => {
            const sum = mealSplit.reduce((a, b) => a + b, 0);
            const percent = Math.min((sum / totalMeals) * 100, 100);
            $("#progress-bar").css("width", `${percent}%`);
            $("#meals-counter").text(`${sum}/${totalMeals}`);
          };

          step.sliders.forEach((slider, idx) => {
            const $row = $("<div/>", { class: "quiz-slider-card" });

            $row.append(`
              <div class="slider-illustration">${slider.icon}</div>
              <div class="slider-label">${slider.label}</div>
              <div class="slider-control">
                <button class="minus-btn" data-idx="${idx}" aria-label="Minus">−</button>
                <span class="slider-value" id="slider-val-${idx}">${mealSplit[idx]}</span>
                <button class="plus-btn" data-idx="${idx}" aria-label="Plus">+</button>
              </div>
            `);

            $sliderBox.append($row);
          });

          // Atualiza visual e salva no quizState
          const updateValues = () => {
            let sum = mealSplit.reduce((a, b) => a + b, 0);
            $(".quiz-btn").prop("disabled", sum !== totalMeals);

            step.sliders.forEach((_, i) => {
              $(`#slider-val-${i}`).text(mealSplit[i]);
            });

            updateProgressBar();
            quizState.responses[quizState.currentStep] = { split: mealSplit };
            QuizMethods.saveResponses();
          };

          // Clique no + e -
          $sliderBox.on("click", ".plus-btn, .minus-btn", function () {
            const idx = Number($(this).data("idx"));
            const isPlus = $(this).hasClass("plus-btn");

            const sum = mealSplit.reduce((a, b) => a + b, 0);
            if (isPlus && sum < totalMeals) mealSplit[idx]++;
            if (!isPlus && mealSplit[idx] > 0) mealSplit[idx]--;

            updateValues();
          });

          $container.append($progressContainer);
          $container.append($sliderBox);
          updateProgressBar();

          // Botão NEXT
          const $btn = $("<button/>", {
            class: "quiz-btn",
            text: "Next",
            disabled: mealSplit.reduce((a, b) => a + b, 0) !== totalMeals,
            click: function () {
              const stepNow = window.quizSteps[quizState.currentStep];
              const splitAns =
                quizState.responses[quizState.currentStep]?.split || [];

              const structuredAnswers = {
                home_cooked: {
                  label: stepNow.sliders[0].label,
                  value: String(splitAns[0] || 0),
                },
                takeout: {
                  label: stepNow.sliders[1].label,
                  value: String(splitAns[1] || 0),
                },
                dine_out: {
                  label: stepNow.sliders[2].label,
                  value: String(splitAns[2] || 0),
                },
              };

              pushQuizEvent(EVENT_NAMES.meal_split, stepNow, {
                value: structuredAnswers,
              });

              QuizMethods.goNextAuto();
            },
          });
          $container.append($btn);

          return;
        }


        // ======================
        // STEP MEAL_QTY (botões especiais)
        // ======================
        if (step.key === "meal_qty") {
          const $optionsList = $("<div/>", { class: "quiz-options-list" });
          step.options.forEach((opt, idx) => {
            const isSel =
              quizState.responses[quizState.currentStep]?.idx === idx;
            const $btn = $("<button/>", {
              type: "button",
              class: "quiz-option-btn" + (isSel ? " selected" : ""),
              click: () => QuizMethods.selectOption(idx),
            });
            $btn.append(
              $("<span/>", { class: "quiz-option-label", text: opt.label })
            );
            if (opt.caption) {
              $btn.append(
                $("<span/>", {
                  class: "quiz-option-caption",
                  text: opt.caption,
                })
              );
            }
            $optionsList.append($btn);
          });
          $container.append($optionsList);
          return;
        }

        // ======================
        // STEP USED_DELIVERY (Yes/No + painel se Yes)
        // ======================
        if (step.key === "used_delivery") {
          const savedResp = quizState.responses[quizState.currentStep] || {};
          const savedValue = savedResp.value; // 'yes' | 'no'
          const $optionsList = $("<div/>", { class: "quiz-options-list" });

          step.options.forEach((opt) => {
            const isSel = savedValue === opt.value;
            const $btn = $("<button/>", {
              type: "button",
              class: "quiz-option-btn" + (isSel ? " selected" : ""),
              click: () => {
                quizState.responses[quizState.currentStep] = {
                  value: opt.value,
                  providers: [],
                  other: "",
                };
                QuizMethods.saveResponses();

                if (opt.value === "no") {
                  // evento final do step + next
                  pushQuizEvent(EVENT_NAMES.used_delivery, step, {
                    value: "no",
                    label: "No",
                  });
                  QuizMethods.goNextAuto();
                  return;
                }

                // YES -> re-render para mostrar painel
                QuizMethods.render();
              },
            });
            $btn.append(
              $("<span/>", { class: "quiz-option-label", text: opt.label })
            );
            if (opt.caption) {
              $btn.append(
                $("<span/>", {
                  class: "quiz-option-caption",
                  text: opt.caption,
                })
              );
            }
            $optionsList.append($btn);
          });

          $("#quiz-container").append($optionsList);

          // se "yes", renderiza o painel logo abaixo do botão Yes
          if (savedValue === "yes") {
            const $yesBtn = $optionsList
              .find(".quiz-option-btn")
              .filter((_, el) => $(el).text().trim().startsWith("Yes"));

            const panel = buildProvidersPanel(
              step,
              savedResp,
              // onChange
              (partial) => {
                quizState.responses[quizState.currentStep] = {
                  value: "yes",
                  providers: Array.isArray(partial.providers)
                    ? partial.providers
                    : [],
                  other: partial.other || "",
                };
                QuizMethods.saveResponses();
              },
              // onNext
              (finalData) => {
                quizState.responses[quizState.currentStep] = {
                  value: "yes",
                  providers: Array.isArray(finalData.providers)
                    ? finalData.providers
                    : [],
                  other: finalData.other || "",
                };
                QuizMethods.saveResponses();

                const v = "yes";
                const label = (finalData.providers || []).join(", ") +
                  (finalData.other ? " | Other: " + finalData.other : "");
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  event: EVENT_NAMES.used_delivery,
                  step: step ? { key: step.key, question: step.question } : undefined,
                  answer: {
                    value: v,
                    providers: label
                  }
                });

                QuizMethods.goNextAuto();
              }
            );

            $yesBtn.after(panel);
          }

          return;
        }

        // ======================
        // OPÇÕES SINGLE / DOUBLE (padrão)
        // ======================
        const optionsLayout = step.layout || "single";
        const $optionsBox = $("<div/>", {
          class: "quiz-options " + optionsLayout,
        });
        let additionalInput = null;

        $.each(step.options, function (idx, opt) {
          const isSelected =
            quizState.responses[quizState.currentStep]?.idx === idx;

          const $optDiv = $("<div/>", {
            class: "quiz-option" + (isSelected ? " selected" : ""),
            tabindex: 0,
            click: function () {
              QuizMethods.selectOption(idx);
            },
            keydown: function (e) {
              if (e.key === "Enter" || e.key === " ")
                QuizMethods.selectOption(idx);
            },
          });

          $optDiv.append(
            $("<span/>", { class: "quiz-option-label", text: opt.label })
          );
          if (opt.caption) {
            $optDiv.append(
              $("<span/>", { class: "quiz-option-caption", text: opt.caption })
            );
          }
          $optionsBox.append($optDiv);

          // Campo extra (hasTextField)
          if (isSelected && opt.hasTextField) {
            additionalInput = $("<input/>", {
              type: "text",
              class: "quiz-input",
              placeholder: "Which one?",
              val: quizState.responses[quizState.currentStep]?.extra || "",
            }).css("marginTop", "16px");

            const $nextBtn = $("<button/>", {
              class: "quiz-btn quiz-next-btn",
              text: "Next",
              disabled: !(
                quizState.responses[quizState.currentStep]?.extra || ""
              ).trim(),
              click: function () {
                // dispara GTM do step agora que temos o extra
                const resp = quizState.responses[quizState.currentStep] || {};
                const labelBase =
                  step.options?.find((o) => o.value === resp.value)?.label ||
                  resp.value ||
                  "";
                const finalLabel = resp.extra
                  ? labelBase + " | " + resp.extra
                  : labelBase;

                const ev = EVENT_NAMES[step.key];
                if (ev)
                  pushQuizEvent(ev, step, {
                    value: resp.value,
                    label: finalLabel,
                  });

                QuizMethods.goNextAfterExtra();
              },
            });

            additionalInput.on("input blur", function () {
              const val = $(this).val();
              quizState.responses[quizState.currentStep].extra = val;
              QuizMethods.saveResponses();
              $nextBtn.prop("disabled", !val.trim());
            });

            additionalInput.on("keydown", function (e) {
              if (e.key === "Enter" && $(this).val().trim()) {
                $nextBtn.trigger("click");
              }
            });

            setTimeout(() => additionalInput.focus(), 100);
            $optionsBox.append(additionalInput, $nextBtn);
          }
        });

        $container.append($optionsBox);
      },

      // Clique em opções "normais"
      selectOption: function (idx) {
        const step = window.quizSteps[quizState.currentStep];
        const selectedOpt = step.options[idx];

        quizState.responses[quizState.currentStep] = {
          idx,
          value: selectedOpt.value,
          extra:
            (selectedOpt.hasTextField &&
              quizState.responses[quizState.currentStep]?.extra) ||
            "",
        };
        QuizMethods.saveResponses();

        // GTM: start (uma única vez)
        if (!quizHasStarted && quizState.currentStep === 0) {
          pushQuizEvent(EVENT_NAMES.start, step, {
            value: selectedOpt.value,
            label: selectedOpt.label || selectedOpt.value,
          });
          quizHasStarted = true;
        }

        // GTM: evento do step (apenas se NÃO tem extra)
        if (!selectedOpt.hasTextField) {
          const ev = EVENT_NAMES[step.key];
          if (ev)
            pushQuizEvent(ev, step, {
              value: selectedOpt.value,
              label: selectedOpt.label || selectedOpt.value,
            });
        }

        if (selectedOpt.hasTextField) {
          QuizMethods.render();
          return;
        }

        QuizMethods.goNextAuto();
        
      },

      goNextAfterExtra: function () {
        QuizMethods.goNextAuto();
      },

      goNextAuto: function () {
        let next = quizState.currentStep + 1;
        if (
          forceSequentialFromStep !== null &&
          next >= window.quizSteps.length
        ) {
          forceSequentialFromStep = null;
        }
        quizState.currentStep = next;
        fadeToNextStep(QuizMethods.render);
      },

      goBack: function () {
        if (quizState.currentStep > 0) {
          quizState.currentStep -= 1;
          fadeToNextStep(QuizMethods.render);
        }
      },

      hasAnsweredStep: function (stepIdx) {
        const step = window.quizSteps[stepIdx];
        const key = step.key || `step${stepIdx + 1}`;
        const storage = getLocalResponsesObject();
        if (storage && storage[key] !== undefined && storage[key] !== null)
          return true;
        return !!quizState.responses[stepIdx];
      },

      renderResult: function ($container) {
        const scores = Array(window.QUIZ_PROFILES.length).fill(0);
        quizState.responses.forEach(function (resp, stepIdx) {
          const step = window.quizSteps[stepIdx];
          if (step?.options && resp?.idx !== undefined) {
            const optScores = step.options[resp.idx]?.scores;
            if (Array.isArray(optScores)) {
              for (let i = 0; i < scores.length; i++) {
                scores[i] += optScores[i] || 0;
              }
            }
          }
        });

        let maxScore = Math.max(...scores);
        let winners = scores
          .map((val, idx) => ({ idx, val }))
          .filter((item) => item.val === maxScore)
          .map((item) => item.idx);

        let winnerIdx = winners[0];
        if (
          winners.length > 1 &&
          quizState.responses.length > 0 &&
          quizState.responses[0]?.idx !== undefined
        ) {
          const firstStepScores =
            window.quizSteps[0].options[quizState.responses[0].idx].scores;
          winnerIdx = winners.sort(
            (a, b) => (firstStepScores[b] || 0) - (firstStepScores[a] || 0)
          )[0];
        }
        const winner = window.QUIZ_PROFILES[winnerIdx];
        window.quizWinner = winner;

        // Exibir Klaviyo form (se existir)
        const klForm = document.querySelector(".klaviyo-form-VuBzek");
        if (klForm) klForm.style.display = "block";

        const $result = $("<div/>", { class: "quiz-result" });
        $result.html(`
          <button id="continue-without-discount" class="continue-without-discount">Continue without discount</button>
        `);
        $container.addClass("last-step");
        $container.append($result);

        $('#continue-without-discount').on('click', function () {
          QuizMethods.saveResponses(winner.toLowerCase().replace(/\s+/g, "-"));
          window.dispatchEvent(new CustomEvent("finishQuiz", { detail: { winner: winner.toLowerCase().replace(/\s+/g, "-") } }));
          $('.klaviyo-form-VuBzek').remove();
          $('#loading').removeClass('hidden');
          pushQuizEvent(
            EVENT_NAMES.completed,
            { key: "result", question: "Quiz result" },
            { value: winner, label: winner }
          );
          pushQuizEvent(
            EVENT_NAMES.skipped,
            { key: "form", question: "Quiz skipped form" },
            { value: winner, label: winner }
          );
          setTimeout(function () {
            $('#loading').addClass('hidden');
            window.location.href = `/pages/${winner
              .toLowerCase()
              .replace(/\s+/g, "-")}-custom-meals`;
          }, 2000);
        });

        // Ouça submissão do Klaviyo e dispare eventos + redirect
        window.addEventListener("klaviyoForms", function (e) {
          if (e?.detail?.type !== "stepSubmit") return;

          QuizMethods.saveResponses(winner.toLowerCase().replace(/\s+/g, "-"));
          window.dispatchEvent(new CustomEvent("finishQuiz", { detail: { winner: winner.toLowerCase().replace(/\s+/g, "-") } }));
          const info = e.detail?.metaData || {};
          pushQuizEvent(
            EVENT_NAMES.form_submitted,
            { key: "form",  question: "form complete" },
            { 
              first_name: info.$first_name || "",
              email: info.$email || "",
              phone: info.$phone_number || ""
            }
          );
          pushQuizEvent(
            EVENT_NAMES.completed,
            { key: "result", question: "Quiz result" },
            { value: winner, label: winner }
          );

          // Identificação/track (mantém os seus campos; com fallback seguro)
          try {
            const saved = localStorage.getItem(QUIZ_KEY);
            const obj = saved ? JSON.parse(saved) : {};

            const goal = obj.goal || "";
            const frequency = obj.frequency || "";
            const exercise_type = obj.exercise_type || "";
            const gender = obj.gender || "";
            const meal_qty = obj.meal_qty || "";
            const pk_qty = obj.pk_qty || "";
            const used_delivery =
              obj.used_delivery?.value === "no"
                ? "no"
                : (obj.used_delivery?.providers || []).join(", ");

            const splitArr = obj.meal_split?.split || [0, 0, 0];
            const quiz_most_activity = {
              home_cooked: splitArr[0] || 0,
              takeout: splitArr[1] || 0,
              dine_out: splitArr[2] || 0,
            };
            const [keyMost] = Object.entries(quiz_most_activity).reduce(
              (a, b) => (a[1] > b[1] ? a : b),
              ["home_cooked", 0]
            );
            const quiz_most_frequent_activity = keyMost;

            const saving = obj.saving || {};

            if (window.klaviyo && typeof klaviyo.push === "function") {
              klaviyo.push([
                "identify",
                {
                  quiz_meal_plan: winner,
                  quiz_goal: goal,
                  quiz_activity_level: frequency,
                  quiz_kind_exercise: exercise_type,
                  Gender: gender,
                  quiz_meals_per_day: meal_qty,
                  quiz_most_frequent_activity,
                  quiz_home_cooked: splitArr[0] || 0,
                  quiz_takeout: splitArr[1] || 0,
                  quiz_dine_out: splitArr[2] || 0,
                  quiz_total_power_kitchen_meals: pk_qty,
                  quiz_used_meal_delivery_before: used_delivery,
                  quiz_result_totalMeals_PowerKitchen:
                    saving.totalMeals_PowerKitchen || "",
                  quiz_result_totalMeals_CookedAtHome:
                    saving.totalMeals_CookedAtHome || "",
                  quiz_result_totalMeals_Takeout:
                    saving.totalMeals_Takeout || "",
                  quiz_result_totalMeals_DineOut:
                    saving.totalMeals_DineOut || "",
                  quiz_result_timeSpend_CookedAtHome:
                    saving.timeSpend_CookedAtHome || "",
                  quiz_result_costMeals_PowerKitchen:
                    saving.costMeals_PowerKitchen || "",
                  quiz_result_costMeals_CookedAtHome:
                    saving.costMeals_CookedAtHome || "",
                  quiz_result_costMeals_Takeout:
                    saving.costMeals_Takeout || "",
                  quiz_result_costMeals_DiningOut:
                    saving.costMeals_DiningOut || "",
                  quiz_result_costOfCooking: saving.costOfCooking || "",
                  quiz_result_costOfTakeout: saving.costOfTakeout || "",
                  quiz_result_costCurrent: saving.costCurrent || "",
                  quiz_result_moneySaved: saving.moneySaved || "",
                  quiz_result_timeSpentCooking: saving.timeSpentCooking || "",
                  quiz_result_timeSaved: saving.timeSaved || "",
                },
              ]);

              klaviyo.track("Quiz Completed", {
                goal,
                frequency,
                exercise_type,
                gender,
                meal_qty,
                quiz_most_frequent_activity,
                pk_qty,
                used_delivery,
              });
            }
          } catch (err) {
            // no-op
          }
          $('#loading').removeClass('hidden');
          setTimeout(function () {
            $('#loading').addClass('hidden');
            window.location.href = `/pages/${winner
              .toLowerCase()
              .replace(/\s+/g, "-")}-custom-meals`;
          }, 2000);
        });
      },

      restart: function () {
        quizState = { currentStep: 0, responses: [], scores: {} };
        forceSequentialFromStep = null;
        quizHasStarted = false;
        localStorage.removeItem(QUIZ_KEY);
        QuizMethods.render();
      },

      saveResponses: function (winner = null) {
        const responsesObj = {};
        quizState.responses.forEach((resp, idx) => {
          if (!resp) return;
          const step = window.quizSteps[idx];
          const key = step.key || `step${idx + 1}`;

          if (step.isSliderStep) {
            responsesObj[key] = { split: resp.split };
          } else if (step.key === "used_delivery") {
            responsesObj[key] = {
              value: resp.value || "",
              providers: Array.isArray(resp.providers) ? resp.providers : [],
              other: resp.other || "",
            };
          } else {
            responsesObj[key] = resp.extra
              ? { value: resp.value, extra: resp.extra }
              : resp.value;
          }
        });
        if (winner) responsesObj["winner"] = winner;
        localStorage.setItem(QUIZ_KEY, JSON.stringify(responsesObj));
      },
    };

    // ======================
    // HELPERS
    // ======================
    function loadQuizResponses() {
      try {
        const saved = localStorage.getItem(QUIZ_KEY);
        if (!saved) return [];
        const obj = JSON.parse(saved);

        return window.quizSteps.map((step, idx) => {
          const key = step.key || `step${idx + 1}`;
          const savedResp = obj[key];

          if (step.isSliderStep && savedResp && Array.isArray(savedResp.split)) {
            return { split: savedResp.split };
          }

          if (step.key === "used_delivery" && savedResp) {
            return {
              value: savedResp.value || "",
              providers: Array.isArray(savedResp.providers)
                ? savedResp.providers
                : [],
              other: typeof savedResp.other === "string" ? savedResp.other : "",
            };
          }

          if (typeof savedResp === "object" && savedResp !== null) {
            const optionIdx = step.options
              ? step.options.findIndex((o) => o.value === savedResp.value)
              : -1;
            return optionIdx >= 0
              ? {
                  idx: optionIdx,
                  value: savedResp.value,
                  extra: savedResp.extra,
                }
              : undefined;
          } else if (typeof savedResp === "string") {
            const optionIdx = step.options
              ? step.options.findIndex((o) => o.value === savedResp)
              : -1;
            return optionIdx >= 0
              ? { idx: optionIdx, value: savedResp }
              : undefined;
          }
          return undefined;
        });
      } catch {
        return [];
      }
    }

    function getLocalResponsesObject() {
      try {
        const saved = localStorage.getItem(QUIZ_KEY);
        return saved ? JSON.parse(saved) : {};
      } catch {
        return {};
      }
    }

    function updateSliderBg(slider) {
      const min = parseInt(slider.min) || 0;
      const max = parseInt(slider.max) || 100;
      const val = parseInt(slider.value) || 0;
      const percent = ((val - min) / (max - min)) * 100;
      slider.style.background = `linear-gradient(to right, #04524C 0%, #04524C ${percent}%, #B9EA91 ${percent}%, #B9EA91 100%)`;
    }

    function buildProvidersPanel(step, saved, onChange, onNext) {
      const selectedInit = Array.isArray(saved?.providers)
        ? [...saved.providers]
        : [];
      const otherInit = typeof saved?.other === "string" ? saved.other : "";

      let selected = selectedInit;
      let otherTxt = otherInit;

      const $wrap = $("<div/>", { class: "providers-wrap" });
      const $list = $("<div/>", { class: "providers-list" });

      (step.providers || []).forEach((p) => {
        const checked = selected.includes(p.value);
        const $row = $(`
          <label class="provider-row">
            <span class="provider-name">${p.label}</span>
            <input type="checkbox" class="provider-check" value="${p.value}" ${
          checked ? "checked" : ""
        }/>
            <span class="provider-box" aria-hidden="true"></span>
          </label>
        `);
        $list.append($row);
      });

      const $other = $(`
        <div class="provider-other">
          <input type="text" class="provider-other-input" placeholder="${
            step.otherPlaceholder || "Write here other company"
          }" value="${otherTxt}">
          <div class="provider-underline"></div>
        </div>
      `);

      const $next = $("<button/>", {
        class: "quiz-btn providers-next",
        text: "Next",
        disabled: !(selected.length || otherTxt.trim()),
      });

      $list.on("change", ".provider-check", function () {
        const v = this.value;
        if (this.checked) {
          if (!selected.includes(v)) selected.push(v);
        } else {
          selected = selected.filter((x) => x !== v);
        }
        $next.prop("disabled", !(selected.length || otherTxt.trim()));
        onChange({ providers: selected, other: otherTxt });
      });

      $other.on("input", ".provider-other-input", function () {
        otherTxt = $(this).val();
        $next.prop("disabled", !(selected.length || otherTxt.trim()));
        onChange({ providers: selected, other: otherTxt });
      });

      $next.on("click", function () {
        onNext({ providers: selected, other: otherTxt });
      });

      $wrap.append($list, $other, $next);
      return $wrap;
    }

    function fadeToNextStep(callback) {
      const $container = $("#quiz-container");
      $container.stop(true, true).fadeOut(300, function () {
        callback();
        $container.fadeIn(300);
      });
    }

    // Renderiza a barra de progresso UMA VEZ
    function renderProgressBar() {
      const $progressContainer = $("<div/>", {
        class: "quiz-progress-container",
      });
      const $progressBg = $("<div/>", { class: "quiz-progress-bg" });
      const $progressFill = $("<div/>", { class: "quiz-progress-fill" });
      $progressBg.append($progressFill);
      $progressContainer.append($progressBg);

      const $progressIcons = $("<div/>", { class: "quiz-progress-icons-bar" });
      $.each(window.progressSteps, function (idx, step) {
        const $iconDiv = $("<div/>", {
          class: "quiz-progress-icon",
          html: step.icon,
          title: step.label,
          "data-step": idx,
          css: { cursor: "pointer" },
        });
        $iconDiv.on("click", function () {
          forceSequentialFromStep = idx;
          quizState.currentStep = idx;
          QuizMethods.render();
        });
        $progressIcons.append($iconDiv);
      });
      $progressContainer.append($progressIcons);

      $(".quiz-progress-bar").prepend($progressContainer);
    }

    function updateProgressBar(currentStep, totalSteps) {
      const form = document.querySelector(".klaviyo-form-VuBzek");
      if (form) form.style.display = "none";

      const percent = (currentStep / (totalSteps - 1)) * 100;
      $(".quiz-progress-fill").css("width", percent + "%");

      $(".quiz-progress-icon").each(function (idx) {
        $(this)
          .toggleClass("active", idx === currentStep)
          .toggleClass("visited", idx < currentStep);
      });
    }

    function showQuizBanner(text) {
      const $banner = $("#quiz-banner");
      if ($banner.length === 0) {
        $("body").append('<div id="quiz-banner" class="quiz-banner"></div>');
      }
      $("#quiz-banner").text(text).fadeIn(200);
    }

    // ======================
    // INIT
    // ======================
    $(document).ready(function () {
      // precisa existir no HTML um container para a barra: <div class="quiz-progress-bar"></div>
      if ($(".quiz-progress-container").length === 0) {
        renderProgressBar();
      }
      QuizMethods.render();
      window.QuizMethods = QuizMethods;
    });
  })(jQuery);
});
